import Settings from 'configs/Settings';

import Request from '@hotmart/request';

Request.register(`${Settings.api.content}/v4/membershipevents`, {
  get: {
    'membershipEvent.listUserEvents': '/'
  },
  post: {
    'membershipEvent.dismissEvent': '/:eventName'
  }
});
